import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Section } from "@/components/kit";
import { brl, brlShort } from "@/lib/api";

const COLORS = { pix: "#10B981", debito: "#3B82F6", credito: "#D4AF37", transferencia: "#8B5CF6", dinheiro: "#F59E0B", boleto: "#EC4899", outros: "#94A3B8", nao_informado: "#475569" };
const LABEL = { pix: "PIX", debito: "Débito", credito: "Crédito", transferencia: "Transferência", dinheiro: "Dinheiro", boleto: "Boleto", outros: "Outros", nao_informado: "Não informado" };
const methodOf = (r) => r.payment_method || (r.card_id ? "credito" : "nao_informado");

export function MethodChart({ rows }) {
  const now = new Date().toISOString().slice(0, 7);
  const months = {};
  const totals = {};
  rows.filter((r) => r.kind === "despesa" && r.date.slice(0, 7) <= now).forEach((r) => {
    const m = r.date.slice(0, 7);
    const k = methodOf(r);
    months[m] = months[m] || { month: m };
    months[m][k] = (months[m][k] || 0) + r.amount;
  });
  const data = Object.keys(months).sort().slice(-6).map((m) => months[m]);
  data.forEach((d) => Object.keys(d).forEach((k) => { if (k !== "month") totals[k] = (totals[k] || 0) + d[k]; }));
  const keys = Object.keys(LABEL).filter((k) => totals[k]);
  const sum = keys.reduce((a, k) => a + totals[k], 0) || 1;
  return (
    <Section title="Gastos por forma de pagamento (últimos 6 meses)" className="mb-6" testid="method-chart">
      {data.length ? (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="h-72 lg:col-span-2">
            <ResponsiveContainer>
              <BarChart data={data}>
                <CartesianGrid stroke="#1E3A6E" strokeDasharray="3 3" />
                <XAxis dataKey="month" stroke="#64748B" fontSize={11} />
                <YAxis stroke="#64748B" fontSize={11} tickFormatter={brlShort} width={70} />
                <Tooltip contentStyle={{ background: "#0B1A33", border: "1px solid #1E3A6E" }} formatter={(v, n) => [brl(v), n]} />
                <Legend />
                {keys.map((k) => <Bar key={k} dataKey={k} name={LABEL[k]} stackId="a" fill={COLORS[k]} />)}
              </BarChart>
            </ResponsiveContainer>
          </div>
          <ul className="space-y-2 text-sm" data-testid="method-legend">
            {keys.sort((a, b) => totals[b] - totals[a]).map((k) => (
              <li key={k} className="flex items-center justify-between gap-2" data-testid={`method-total-${k}`}>
                <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS[k] }} />{LABEL[k]}</span>
                <span className="num">{brl(totals[k])} <span className="text-slate-400">· {((totals[k] / sum) * 100).toFixed(1).replace(".", ",")}%</span></span>
              </li>
            ))}
          </ul>
        </div>
      ) : <p className="text-sm text-slate-400">Sem despesas no período.</p>}
    </Section>
  );
}
